export default __webpack_public_path__ + "static/media/re4.86413e74.jpg";